import { useState } from "react";

export const SecretIcon = ({ status }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      className={`${
        status ? "bg-blue-1 border-blue-1" : "bg-white border-white"
      } g p-1 border rounded  hover:border-blue-1`}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" fill="none" viewBox="0 0 22 20">
        <path
          fill={status ? "#ffff" : hover ? "#1062D0" : "#AEAEAE"}
          d="M5.39 19.75a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0-7.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm11.25 7.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0-7.5a3 3 0 1 0 0 5.999 3 3 0 0 0 0-5.999Z"
        />
        <path
          fill={status ? "#ffff" : hover ? "#1062D0" : "#AEAEAE"}
          d="M9.14 14.508h3.75v1.5H9.14v-1.5Zm11.625-6.75h-19.5a.75.75 0 1 0 0 1.5h19.5a.75.75 0 0 0 0-1.5Z"
        />
        <path
          fill={status ? "#ffff" : hover ? "#1062D0" : "#AEAEAE"}
          d="M19.43 9.25H2.6l1.5-7.313A2.1 2.1 0 0 1 6.118.25h9.787a2.1 2.1 0 0 1 2.055 1.688l1.47 7.312Zm-15-1.5H17.6l-1.11-5.52a.6.6 0 0 0-.585-.48H6.118a.6.6 0 0 0-.585.48L4.43 7.75Z"
        />
      </svg>
    </div>
  );
};
